<div class="investing-activities-table">
    <div class="table-title">
        <ham-inline-table-cell-edit
            [value]="investingActivitiesTitle"
            (save)="onSaveTitle($event)"
        ></ham-inline-table-cell-edit>
    </div>

    <div class="form-container" *ngIf="form">
        <form [formGroup]="form">
            <ng-container formArrayName="dataSource" *ngIf="!isVirtualized">
                <table>
                    <thead>
                        <tr>
                            <th class="bold aumOverflowEdit" style="width: 55.6%">
                                <span>{{ currency }}</span>
                            </th>

                            <th class="aumHighlight" style="width: 22%">
                                <span>{{ currentYearDate | dateLocale }}</span>
                            </th>

                            <th style="width: 18%">
                                <span>{{ previousYearDate | dateLocale }}</span>
                            </th>

                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let group of dataSource.controls; let rowIndex = index; trackBy: trackByIndex">
                            <tr class="no-border" [formGroup]="group">
                                <td class="bold">
                                    <div class="error" *ngIf="!group.get('parent.name').value">
                                        {{ 'aumico_annual_report_cash_flow_mandatory_field' | i18next }}
                                    </div>
                                    <ham-inline-table-cell-edit
                                        [value]="group.get('parent.name').value"
                                        (save)="onSaveFliName($event, rowIndex)"
                                        [isEditing]="
                                            group.get('parent.isCustom')?.value && !group.get('parent.name').value
                                        "
                                    ></ham-inline-table-cell-edit>
                                </td>
                                <td class="aumHighlight"></td>
                                <td></td>
                                <td>
                                    <span class="ham-icon" (click)="removeGroup(rowIndex)">
                                        <i class="remove-icon grey-remove-icon"></i>
                                    </span>
                                </td>
                            </tr>
                            <tr
                                [ngClass]="{ 'no-border': childIndex === group.get('children').controls?.length - 1 }"
                                *ngFor="let child of group.get('children').controls; let childIndex = index; trackBy: trackByIndex"
                                [formGroup]="child"
                                class="hover-highlight"
                            >
                                <td>
                                    <div class="input-badge-wrapper">
                                        <input class="text-input" type="text" formControlName="name" hamInput />
                                        <div
                                            class="ham-badge"
                                            hamBadge
                                            color="yellow"
                                            size="small"
                                            [hasCancelIcon]="false"
                                        >
                                            {{ 'aumico_annual_report_cash_flow_manual' | i18next }}
                                        </div>
                                    </div>
                                </td>
                                <td class="aumHighlight">
                                    <input
                                        class="number-input"
                                        formControlName="calculatedCurrentValue"
                                        type="number"
                                        hamInput
                                    />
                                </td>
                                <td>
                                    <input
                                        class="number-input"
                                        formControlName="calculatedPreviousValue"
                                        type="number"
                                        hamInput
                                    />
                                </td>
                                <td>
                                    <span class="ham-icon" (click)="removeRow(group, childIndex)">
                                        <i class="remove-icon grey-remove-icon"></i>
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td class="add-row">
                                    <ham-button
                                        [outline]="true"
                                        size="xs"
                                        icon="assets/hamIcons/plus-outline.svg"
                                        (buttonClick)="addRow(group)"
                                    >
                                        {{ 'aumico_annual_report_cash_flow_investing_add_row' | i18next }}
                                    </ham-button>
                                </td>
                                <td class="aumHighlight"></td>
                                <td></td>
                            </tr>
                        </ng-container>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td>
                                <span class="total-text">
                                    {{
                                        'aumico_annual_report_cash_flow_total_investing_activities'
                                            | i18nextWithLocale : reportLocale
                                    }}
                                </span>
                            </td>

                            <td class="aumHighlight">
                                <span class="margin-top-70">
                                    {{ currentTotal | finNumber : numberFormat }}
                                </span>
                            </td>

                            <td>
                                <span class="margin-top-70">
                                    {{ previousTotal | finNumber : numberFormat }}
                                </span>
                            </td>

                            <td></td>
                        </tr>
                    </tfoot>
                </table>
            </ng-container>

            <!-- Virtualized rendering for very large datasets (REV-21417): the nested parent/children
                 groups are flattened into a uniform display-row list (investingDisplayRows) so the
                 fixed-size viewport renders only the visible rows — thousands of rows no longer freeze
                 / OOM the tab. Normal-sized tables keep the full nested table above. -->
            <div *ngIf="isVirtualized" class="cfs-virtual">
                <div class="cfs-vrow cfs-vheader">
                    <div class="cfs-vcell name">{{ currency }}</div>
                    <div class="cfs-vcell num aumHighlight">{{ currentYearDate | dateLocale }}</div>
                    <div class="cfs-vcell num">{{ previousYearDate | dateLocale }}</div>
                    <div class="cfs-vcell action"></div>
                </div>
                <cdk-virtual-scroll-viewport [itemSize]="VIRTUAL_ROW_HEIGHT" class="cfs-viewport">
                    <div
                        class="cfs-vrow"
                        *cdkVirtualFor="let row of investingDisplayRows; let i = index; trackBy: trackByIndex"
                        [ngSwitch]="row.kind"
                    >
                        <!-- Parent (section) row -->
                        <ng-container *ngSwitchCase="'parent'">
                            <div class="cfs-vcell name bold">
                                <ham-inline-table-cell-edit
                                    [value]="row.group.get('parent.name').value"
                                    (save)="onSaveFliName($event, row.groupIndex)"
                                    [isEditing]="
                                        row.group.get('parent.isCustom')?.value && !row.group.get('parent.name').value
                                    "
                                ></ham-inline-table-cell-edit>
                            </div>
                            <div class="cfs-vcell num aumHighlight"></div>
                            <div class="cfs-vcell num"></div>
                            <div class="cfs-vcell action">
                                <span class="ham-icon" (click)="removeGroup(row.groupIndex)">
                                    <i class="remove-icon grey-remove-icon"></i>
                                </span>
                            </div>
                        </ng-container>
                        <!-- Child (line item) row -->
                        <ng-container *ngSwitchCase="'child'">
                            <div class="cfs-vcell name" [formGroup]="row.child">
                                <div class="input-badge-wrapper">
                                    <input class="text-input" type="text" formControlName="name" hamInput />
                                    <div class="ham-badge" hamBadge color="yellow" size="small" [hasCancelIcon]="false">
                                        {{ 'aumico_annual_report_cash_flow_manual' | i18next }}
                                    </div>
                                </div>
                            </div>
                            <div class="cfs-vcell num aumHighlight" [formGroup]="row.child">
                                <input class="number-input" formControlName="calculatedCurrentValue" type="number" hamInput />
                            </div>
                            <div class="cfs-vcell num" [formGroup]="row.child">
                                <input class="number-input" formControlName="calculatedPreviousValue" type="number" hamInput />
                            </div>
                            <div class="cfs-vcell action">
                                <span class="ham-icon" (click)="removeRow(row.group, row.childIndex)">
                                    <i class="remove-icon grey-remove-icon"></i>
                                </span>
                            </div>
                        </ng-container>
                        <!-- Add-row button row -->
                        <ng-container *ngSwitchCase="'addrow'">
                            <div class="cfs-vcell name">
                                <ham-button
                                    [outline]="true"
                                    size="xs"
                                    icon="assets/hamIcons/plus-outline.svg"
                                    (buttonClick)="addRow(row.group)"
                                >
                                    {{ 'aumico_annual_report_cash_flow_investing_add_row' | i18next }}
                                </ham-button>
                            </div>
                            <div class="cfs-vcell num aumHighlight"></div>
                            <div class="cfs-vcell num"></div>
                            <div class="cfs-vcell action"></div>
                        </ng-container>
                    </div>
                </cdk-virtual-scroll-viewport>
                <div class="cfs-vrow cfs-vfooter">
                    <div class="cfs-vcell name text">
                        {{ 'aumico_annual_report_cash_flow_total_investing_activities' | i18nextWithLocale : reportLocale }}
                    </div>
                    <div class="cfs-vcell num aumHighlight">{{ currentTotal | finNumber : numberFormat }}</div>
                    <div class="cfs-vcell num">{{ previousTotal | finNumber : numberFormat }}</div>
                    <div class="cfs-vcell action"></div>
                </div>
            </div>
        </form>
        <div class="add-row">
            <ham-button
                [outline]="true"
                size="xs"
                icon="assets/hamIcons/plus-outline.svg"
                (buttonClick)="addFliBlock()"
            >
                {{ 'aumico_annual_report_cash_flow_investing_add_new_section' | i18next }}
            </ham-button>
        </div>
    </div>
</div>

<ham-confirm-decline-modal
    class="confirm-decline-modal"
    *ngIf="showDeleteModal"
    (cancel)="onCancelDelete()"
    (action)="onDeleteFliRow()"
    footerAlignment="center"
    actionBtnText="{{ 'aumico_reports_confirm_delete' | i18next }}"
    noActionBtnText="{{ 'aumico_reports_cancel_delete' | i18next }}"
>
    <ham-general-confirm-decline-modal-body
        [text]="'aumico_annual_report_delete_item_confirmation_text' | i18next"
    ></ham-general-confirm-decline-modal-body>
</ham-confirm-decline-modal>
